// benefit slider
const swiperproject = new Swiper(".benefit-slider", {
  loop: true,
  spaceBetween: 0,
  slidesPerView: 1,
  speed: 800,
  effect: "fade",
  watchSlidesProgress: true,
  pagination: {
    el: ".benefit-slider-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});
